<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.2743 4.10422C11.3685 3.53916 11.8574 3.125 12.4302 3.125H13.5698C14.1426 3.125 14.6315 3.53916 14.7257 4.10422L14.8809 5.03527C14.9545 5.47722 15.2805 5.83165 15.6943 6.00346C16.1083 6.17534 16.5836 6.15238 16.9484 5.89185L17.7167 5.34306C18.1828 5.01009 18.8214 5.06294 19.2265 5.46801L20.0322 6.27379C20.4373 6.67886 20.4902 7.31742 20.1572 7.78357L19.6082 8.55215C19.3478 8.91679 19.3248 9.39201 19.4966 9.80587C19.6684 10.2196 20.0227 10.5455 20.4646 10.6191L21.3958 10.7743C21.9608 10.8685 22.375 11.3574 22.375 11.9302V13.0698C22.375 13.6426 21.9608 14.1315 21.3958 14.2257L20.4647 14.3809C20.0228 14.4545 19.6684 14.7805 19.4966 15.1943C19.3247 15.6082 19.3476 16.0836 19.6082 16.4483L20.1568 17.2165C20.4898 17.6827 20.437 18.3212 20.0319 18.7263L19.2261 19.5321C18.821 19.9371 18.1825 19.99 17.7163 19.657L16.948 19.1082C16.5833 18.8477 16.1081 18.8248 15.6942 18.9966C15.2805 19.1684 14.9545 19.5227 14.8809 19.9646L14.7257 20.8958C14.6315 21.4608 14.1426 21.875 13.5698 21.875H12.4302C11.8574 21.875 11.3685 21.4608 11.2743 20.8958L11.1191 19.9647C11.0455 19.5228 10.7195 19.1684 10.3057 18.9966C9.89175 18.8247 9.4164 18.8476 9.05167 19.1082L8.28331 19.657C7.81716 19.99 7.1786 19.9371 6.77353 19.532L5.96775 18.7262C5.56268 18.3212 5.50983 17.6826 5.8428 17.2165L6.39179 16.4479C6.65225 16.0832 6.67522 15.608 6.50339 15.1941C6.33163 14.7804 5.97729 14.4545 5.53544 14.3809L4.60422 14.2257C4.03916 14.1315 3.625 13.6426 3.625 13.0698V11.9302C3.625 11.3574 4.03916 10.8685 4.60422 10.7743L5.53527 10.6191C5.97722 10.5455 6.33165 10.2195 6.50346 9.8057C6.67534 9.39172 6.65239 8.91635 6.39185 8.5516L5.84321 7.7835C5.51024 7.31735 5.56309 6.6788 5.96816 6.27372L6.77394 5.46794C7.17901 5.06287 7.81757 5.01002 8.28372 5.34299L9.05205 5.8918C9.41671 6.15227 9.89196 6.17523 10.3058 6.0034C10.7196 5.83164 11.0455 5.47728 11.1191 5.03542L11.2743 4.10422Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M16.1257 12.5C16.1257 14.2259 14.7266 15.625 13.0007 15.625C11.2748 15.625 9.87573 14.2259 9.87573 12.5C9.87573 10.7741 11.2748 9.37502 13.0007 9.37502C14.7266 9.37502 16.1257 10.7741 16.1257 12.5Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgSettings',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
